import md5 from "md5";

export const hashMd5 = (string) => md5(string);
